import clsx from 'clsx'
import { type ComponentPropsWithoutRef, type FC } from 'react'

import { StatusTag } from '@/components/elements'
import {
  type ShipmentOrderStatusType,
  SHIPMENT_ORDER_STATUS_TYPE,
  SHIPMENT_ORDER_STATUS_TYPE_LABEL
} from '@/libs/api/types'

type StatusTagProps = ComponentPropsWithoutRef<typeof StatusTag>
type TagColor = StatusTagProps['color']

type Props = Omit<StatusTagProps, 'color'> & {
  /** 配送依頼ステータス*/
  statusType: ShipmentOrderStatusType
}

const TAG_COLOR_MAP: Record<ShipmentOrderStatusType, TagColor> = {
  [SHIPMENT_ORDER_STATUS_TYPE.PENDING]: 'secondary',
  [SHIPMENT_ORDER_STATUS_TYPE.ALLOCATED]: 'primary',
  [SHIPMENT_ORDER_STATUS_TYPE.DISPATCHED]: 'green'
}

/**
 * 配送依頼ステータスのTag
 */
export const ShipmentOrderStatusTypeTag: FC<Props> = ({
  className,
  statusType,
  size,
  ...props
}) => {
  return (
    <StatusTag
      {...props}
      className={clsx([
        size === 'small' ? 'min-w-[84px]' : 'min-w-[136px]',
        className
      ])}
      color={TAG_COLOR_MAP[statusType]}
      size={size}
    >
      {SHIPMENT_ORDER_STATUS_TYPE_LABEL[statusType]}
    </StatusTag>
  )
}
